<div
  class="custom-multi-dropdown-container"
  (click)="toggleDropdownState($event)"
  (document:click)="handleOutsideClick($event)"
>
  <ng-multiselect-dropdown
    [placeholder]="placeHolderTitle"
    [settings]="dropdownSettings"
    [data]="dropdownList"
    [(ngModel)]="selectedItems"
    (onSelect)="onItemSelect($event, dropdownList)"
    (onDeSelect)="onItemDeSelect($event, dropdownList)"
  >
  </ng-multiselect-dropdown>
  <img src="/assets/icons/Arrow.svg" class="custom-carat-icon" [class.rotated]="isToggle"  alt="carrot icon">
</div>
